import React, {useEffect, useState} from "react";
import {fetchRequestMyRequests} from "../../api/crm/feedback";
import supportImage from "../../images/crm/support.webp";
import siteStructure from "../siteStructure.json";
import {getImagesStructure} from "../utils/siteStructure";
import {useTheme} from "../header/Header";

const images = require.context('../../images/', true, /\.(webp|webm)$/);

export function convertDateToPoint(date) {
    let day = date.slice(8)
    let month = date.slice(5, 7)
    let year = date.slice(0, 4)

    return `${day}.${month}.${year}`
}

// const testData = [
//     {
//         city:"Канаш",
//         commentFromManager:"",
//         contactPhone:"+79999999999",
//         email:"vipal921@yandex.ru",
//         id:"12345",
//         manager:"",
//         name:"Alex",
//         object:"Клапан обратный пружинный DN 50 4977.09.114-0000.СБ",
//         status:"В работе",
//         text:"Сколько стоят эти клапаны? Они есть в наличии?",
//         time_begin:"2025-03-17T15:44:12.997Z",
//         time_close:"0001-01-01T00:00:00Z",
//         time_work:"2025-03-18T15:55:59.997Z"
//     },
//     {
//         city:"Казань",
//         commentFromManager:"от 1-го до 2 месяцев.",
//         contactPhone:"+79999999999",
//         email:"vipal921@yandex.ru",
//         id:"43211",
//         manager:"Александр",
//         name:"Alex",
//         object:"Стальные резервуары",
//         status:"Закрыта",
//         text:"Какие сроки выполнения при заказе этого контейнера?",
//         time_begin:"2025-03-19T09:12:17.997Z",
//         time_close:"2025-03-19T10:00:00Z",
//         time_work:"2025-03-19T09:44:02Z"
//     },
//     {
//         city:"Чебоксары",
//         commentFromManager:"Спасибо за обращение, к сожалению эта продукция больше не производится. Подробности можете прочитать в разделе продукция под этой страницей.",
//         contactPhone:"+79999999999",
//         email:"vipal921@yandex.ru",
//         id:"43254325243511",
//         manager:"Дмитрий",
//         name:"Alex",
//         object:"Алюминиевые резервуары",
//         status:"Отменена",
//         text:"Добрый день, а чем-то отличается от версии с амортизатором, кроме его отсутствия?",
//         time_begin:"2025-03-22T09:12:17.997Z",
//         time_close:"2025-03-24T11:44:12Z",
//         time_work:"2025-03-23T09:44:02Z"
//     },
//
// ]

export default function MyRequests() {

    const [title, setTitle] = useState("Мои заявки")
    const [requestList, setRequestList] = useState([])
    const {theme} = useTheme()

    useEffect( () => {

       async function getRequsetsList() {

           const token = localStorage.getItem('token');
           try {
               const data = await fetchRequestMyRequests(token)

               // data.push(testData[0])
               // data.push(testData[1])
               // data.push(testData[2])

               if(Object.keys(data).includes("error")){
                   setTitle(data.error)
                   return
               }

               setRequestList(data)
           } catch (error) {
               setTitle("Нет заявок")
               console.log(error)
           }
        }

        getRequsetsList()

    }, [])

    return (
        <div className={"myRequests"}>
            <div className={`complexBack ${theme}`}> </div>

            <h1 className={`${theme === "dark"? null : "lightTitle"}`}>{title}</h1>
            <RequestList requestList={requestList}/>
        </div>
    )
}

const LoadingDots = () => {
    return (
        <div className="myRequestsWaiting">
            <span className="dot">.</span>
            <span className="dot">.</span>
            <span className="dot">.</span>
        </div>
    )
}

function compareDate(date_start, date_end) {

    return convertDateToPoint(date_start.slice(0, 10)) === convertDateToPoint(date_end.slice(0, 10))

}

function RequestList({requestList}) {

    const imagesConst = getImagesStructure(siteStructure)
    const {theme} = useTheme()

    function handleStatus(status){
        switch (status) {
            case "Заявка":
                return {text:"Ожидает ответа", color: "#dd6326"}
            case "В работе":
                return {text:"В работе", color: "#01a1ff"}
            case "Закрыта":
                return {text:"Закрыта", color: "#11c44c"}
            case "Отменена":
                return {text:"Отменена", color: "#b31919"}
            default:
                return {text:"Ошибка", color: "#b31919"}
        }
    }

    const getImage = (path) => {
        try {
            if(imagesConst[path]) {
                return images(`./${imagesConst[path]}`);
            }
            return images(`./noImg.webp`);
        } catch (error) {
            console.log(`Изображение ${imagesConst[path]} не найдено`)
            return images(`./noImg.webp`);
        }
    }

    return (
        <div className={"myRequestList"}>
            {requestList.map((e, index) => {
                // Создаем уникальный ключ из time_begin + index
                // time_begin уникален для каждой заявки, т.к. это timestamp
                const uniqueKey = e.time_begin || `item-${index}`;

                return (
                    <div className={`myRequestItem ${theme}`} key={uniqueKey}>
                        <div className={e.object !== "request"? "myRequestProduct" : "myRequestSupport"}>
                            {e.object === "request"?
                                <img src={supportImage} alt="no-img"/> :
                                <>
                                    <img src={getImage(e.object)} alt="no-img"/>
                                    <p>{e.object}</p>
                                </>
                            }
                        </div>
                        <div className={`myRequestsBlock ${theme}`}>
                            <div>
                                <h4>{convertDateToPoint(e.time_begin.slice(0,10))}</h4>
                                <div className={"myRequestsStatus"} style={{background: handleStatus(e.status).color}}>
                                    {handleStatus(e.status).text}
                                </div>
                                <div className={"myRequestsUserQuestionWrapper"}>
                                    <span>Ваш вопрос</span>
                                    <p>{e.text}</p>
                                    <span>{e.time_begin.slice(11,19)}</span>
                                </div>

                                {e.status === "Заявка"? <LoadingDots /> : <WorkTime data={e} timeType={"time_work"} text={"Принят в работу"}/>}

                                {e.status === "В работе"?  <LoadingDots /> : null}

                                {e.commentFromManager === ""? null :
                                    <div className={"myRequestsManagerAnswerWrapper"}>
                                        <div className={"myRequestsUserQuestionWrapper"}>
                                            <span>Менеджер</span>
                                            <p>{e.commentFromManager}</p>
                                            <span>{e.time_close.slice(11,19)}</span>
                                        </div>

                                        {(e.status === "Закрыта" || e.status === "Отменена") && !compareDate(e.time_begin, e.time_close)?
                                            <h4 className={"myRequestsWorkTime"}>{`Дата ответа ${convertDateToPoint(e.time_close.slice(0,10))}`}</h4>
                                            : null
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

function WorkTime({data, timeType, text}) {

    const time = data[timeType].slice(11,19)
    const date = compareDate(data.time_begin, data[timeType])? "" : convertDateToPoint(data[timeType].slice(0,10))

    return (
        <h4 className={"myRequestsWorkTime"}>{`${text} ${date} ${time}`}</h4>
    )

}